/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const KindEnum = {
    Person: 'Person',
    Organization: 'Organization'
} as const;
export type KindEnum = typeof KindEnum[keyof typeof KindEnum];


export function instanceOfKindEnum(value: any): boolean {
    for (const key in KindEnum) {
        if (Object.prototype.hasOwnProperty.call(KindEnum, key)) {
            if (KindEnum[key as keyof typeof KindEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function KindEnumFromJSON(json: any): KindEnum {
    return KindEnumFromJSONTyped(json, false);
}

export function KindEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): KindEnum {
    return json as KindEnum;
}

export function KindEnumToJSON(value?: KindEnum | null): any {
    return value as any;
}

export function KindEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): KindEnum {
    return value as KindEnum;
}

